module.exports = __webpack_public_path__ + "static/media/warning.cf7dd4e5.svg";